import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus } from "lucide-react";

const EMPTY = { risk: "", likelihood: "Possible", severity: "Moderate", mitigation: "", residual: "Medium", owner: "" };
const FIELDS = ["risk", "likelihood", "severity", "mitigation", "residual", "owner"];

export function RiskForm({ onAdd }) {
  const [f, setF] = useState(EMPTY);
  const submit = async () => {
    if (!f.risk.trim() || !f.mitigation.trim()) return;
    if (await onAdd(f)) setF(EMPTY);
  };
  return (
    <div className="mt-4 grid gap-2 sm:grid-cols-3 lg:grid-cols-7" data-testid="risk-form">
      {FIELDS.map((k) => (
        <Input key={k} placeholder={k} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`risk-field-${k}`} />
      ))}
      <Button onClick={submit} className="bg-accent font-bold hover:bg-accent/90" data-testid="risk-add-btn"><Plus className="mr-1 h-4 w-4" />Add</Button>
    </div>
  );
}
